import getAdminRow from "../DataDisplayRow/AdminRow";
import DataDisplayRowI from "../DataDisplayRowI";
import DataDisplayTable from "../DataDisplayTable";


class AdminTable extends DataDisplayTable {
    #row!: DataDisplayRowI;

    generateRow(): DataDisplayRowI {
        return this.#row = getAdminRow()
    }
}

let adminTable: AdminTable | null = null;

export default function getAdminTable(): AdminTable {
    if (adminTable === null)
        adminTable = new AdminTable()
    return adminTable
}